export default __webpack_public_path__ + "static/media/B0007.dda1a367.png";